import { createContext, useContext } from "react";
import type { Identifier } from "ra-core";

// Detaljpanel ved siden av tabellen (Macro-planen, neste release): når en
// tabell ligger inni en RowSelectContext, åpner et klikk på raden panelet i
// stedet for å navigere bort fra lista. Lista blir stående montert, så
// filter, sortering og scrollposisjon er som før når panelet lukkes.
export type RowSelect = {
  selectedId: Identifier | null;
  // fromKeyboard: åpnet med Enter, så fokus flyttes inn i panelet.
  select: (id: Identifier, options?: { fromKeyboard?: boolean }) => void;
};

// Raden får id-en sin her, så panelet kan sette fokus tilbake på den når det
// lukkes (WCAG 2.4.3).
export const ROW_ID_ATTR = "data-row-id";

export const RowSelectContext = createContext<RowSelect | null>(null);

export const useRowSelect = () => useContext(RowSelectContext);

// Klikk i lenker, knapper, felt og nedtrekk (også i portaler som ikke ligger
// inni raden) skal gjøre det de gjør, ikke åpne panelet.
const INTERACTIVE =
  "a,button,input,select,textarea,label,[role=button],[role=checkbox],[role=combobox],[role=option],[role=menuitem],[role=switch],[contenteditable=true]";

export const isPlainRowClick = (
  row: HTMLElement,
  target: EventTarget | null,
): boolean => {
  if (!(target instanceof Element)) return false;
  if (!row.contains(target)) return false;
  const interactive = target.closest(INTERACTIVE);
  return !interactive || !row.contains(interactive) || interactive === row;
};
